import { Component, input, output } from '@angular/core';
import { SessionGuideStepEnum } from '../../../shared/models/session-guide.model';

@Component({
  standalone: false,
  selector: 'app-session-guide-steps',
  templateUrl: './session-guide-steps.component.html',
  styleUrls: ['./session-guide-steps.component.scss'],
})
export class SessionGuideStepsComponent {
  activeStep = input<SessionGuideStepEnum>();
  stepClick = output<SessionGuideStepEnum>();

  steps = [
    {
      id: SessionGuideStepEnum.PICK_SESSION_TYPE,
      order: 1,
      title: 'Know Your Session Type',
    },
    {
      id: SessionGuideStepEnum.SETUP_PLATFORM,
      order: 2,
      title: 'Set Up Your Platform',
    },
    {
      id: SessionGuideStepEnum.CREATE_SESSION,
      order: 3,
      title: 'Create a Session & Supplier',
    },
  ];
}
